import { useMemo } from "react";
import { toastr } from "react-redux-toastr";
import available_countries_options from "utils/select_options/available_countries";
import { client, getApiErrorMessage } from "utils/api";

import { Dashboard, Select } from "components";

import useGet from "hooks/useGet";

const VatRates = ({ data, product_group_id, refetch }) => {
  const { is_loading, data: vat_rates } = useGet({
    query: ["vat_rates"],
    path: "/vat_rates",
    context: "list",
    search: { per_page: 10_000 },
  });

  const vat_rates_options_per_country = useMemo(
    () =>
      available_countries_options.reduce((acc, acu) => {
        acc[acu.value] = vat_rates
          ?.filter(({ country_code }) => country_code === acu.value)
          .map(({ id, name }) => ({ label: name, value: id }));
        return acc;
      }, {}),
    [vat_rates]
  );

  const handleChange = async ({ vat_rate_id, product_group_vat_rate_id }) => {
    try {
      if (product_group_vat_rate_id) {
        await client.put(
          `/product_group_vat_rates/${product_group_vat_rate_id}`,
          {
            vat_rate_id,
          }
        );
      } else {
        await client.post("/product_group_vat_rates", {
          product_group_id,
          vat_rate_id,
        });
      }

      refetch();
      toastr.success("Sukces", "Zaktualizowano stawkę VAT");
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    }
  };

  return (
    <Dashboard header={{ title: "Stawki VAT", icon: "info" }}>
      {!is_loading && (
        <div className="dashboard__body">
          {available_countries_options.map(({ value }) => {
            const options = vat_rates_options_per_country[value];
            const product_group_vat_rate = data.find(({ vat_rate }) =>
              options?.map(({ value }) => value).includes(vat_rate.id)
            );
            return (
              <div className="row m-b-10" key={value}>
                <div className="box-12">
                  <Select
                    label={`Kraj: ${value}`}
                    name="vat_rate_id"
                    defaultValue={options?.find(
                      ({ value }) =>
                        value === product_group_vat_rate?.vat_rate?.id
                    )}
                    options={options}
                    handleChange={(vat_rate_id) =>
                      handleChange({
                        vat_rate_id,
                        product_group_vat_rate_id: product_group_vat_rate?.id,
                      })
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Dashboard>
  );
};

export default VatRates;
